import React, { useState } from "react";
import "./ContactUsPopover.css";
import { toast } from "react-toastify";
import { chatFeedbackApi } from "../../services/api/chatFeedback.api";
import LabelInput from "../FeedbackPopover/LableInputs"; // reuse existing input

const REQUEST_TYPES = [
  "Access Request",
  "Question",
  "Suggestion",
  "Bug Report",
] as const;

type RequestType = (typeof REQUEST_TYPES)[number];

interface ContactUsPopoverProps {
  open: boolean;
  onClose: () => void;
}

const ContactUsPopover: React.FC<ContactUsPopoverProps> = ({ open, onClose }) => {
  const [submitting, setSubmitting] = useState(false);
  const [requestType, setRequestType] = useState<RequestType | "">("");
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setRequestType("");
    setMessage("");
    onClose();
  };

  const validate = (): boolean => {
    if (!requestType) {
      toast.error("Please select a request type");
      return false;
    }
    if (!message.trim()) {
      toast.error("Please enter a message");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);

    try {
      await chatFeedbackApi.submitContactUs({
        request_type: requestType,
        // Spaces around the message are dropped; what's inside is kept as typed.
        message: message.trim(),
      });
      toast.success("Thanks for reaching out!");
      handleClose();
    } catch {
      toast.error("Something went wrong, please try again!");
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div className="cup-overlay" onClick={handleClose}>
      <div className="cup-card" onClick={(e) => e.stopPropagation()}>
        <div className="cup-header">
          <h3>Contact Us</h3>
          <button className="cup-close" onClick={handleClose} aria-label="Close">
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form className="cup-body" onSubmit={handleSubmit}>
          <div className="cup-row">
            <label className="label-floating">
              Request Type
              <span className="required-asterisk"> *</span>
            </label>{" "}
            <select
              className="cup-select"
              value={requestType}
              onChange={(e) => setRequestType(e.target.value as RequestType)}
            >
              <option value="" disabled>
                Select a request type
              </option>
              {REQUEST_TYPES.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          <div className="cup-row">
            <LabelInput
              label="Message"
              required
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Tell us how we can help..."
              maxLength={5000}
            />
          </div>

          <div className="cup-actions">
            <button
              type="button"
              className="cup-btn ghost"
              onClick={handleClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="cup-btn primary"
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUsPopover;
